module.exports = "https://cdn.realtymogul.com/static/media/img_nav.e631eb36.png";